
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/financial/review",
      function () {
        return require("private-next-pages/en/ir/financial/review.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/financial/review"])
      });
    }
  